module.exports = __webpack_public_path__ + "img/aktiviti-pembersihan.af00e467.jpeg";